import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal'
import '../../App.css'
import { Button } from '@material-ui/core';


class App extends Component {

    constructor() {
        super();
        this.state = {

            change: false,

            showuse: false
        }
    }



    componentWillReceiveProps(props) {
        this.setState({ showuse: props.opens })
    }

    render() {
        const abc = [1, 1, 1, 1, 1, 1, 1, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1]
        return (
            <div style={{ marginTop: "100px" }}>
                <Modal
                    show={this.state.showuse}
                    onHide={this.props.onHide}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                // backdrop={"static"}
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Uploaded Prove
              </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <div className="in">
                            {abc.map((v) => {
                                return (

                                    <div class="card" style={{ marginBottom: "10px" }}>

                                        <div class="row no-gutters">
                                            <div class="col-auto">
                                                <img src="https://www.planetware.com/photos-large/MEX/mexico-top-places-cancun-mayan-riviera.jpg" class="img-fluid" width={300} alt="" />
                                            </div>
                                            <div class="col">
                                                <div class="card-block px-2">
                                                    <h4 class="card-title">Title</h4>
                                                    <p class="card-text">Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In </p>

                                                </div>
                                            </div>
                                        </div>


                                    </div>)
                            })}


                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={() => { this.setState({ showuse: false }) }} className="btn btn-danger">Close</button>
                    </Modal.Footer>
                </Modal>



            </div>
        )
    }
}
export default App;